// extracted by mini-css-extract-plugin
export default {"icon":"ServiceRowRemove--icon--9616b8"};